import { Avatar } from "antd";
import React from "react";

import { useUserStore } from "@/store/zustand/useUserStore";

const UserAvatar = ({ ...props }) => {
  const user = useUserStore((state) => state.user);
  return (
    <Avatar {...props} src={user?.profile_picture} className="!bg-[#5EA3DD]">
      {user?.name
        ? user.name
            .trim()
            .split(" ")
            .map((n) => n[0].toUpperCase())
            .join("")
        : ""}
    </Avatar>
  );
};

export default UserAvatar;
